export default function sendGAEvent(element, type, isMobile){
    sendEvent(getEventData(element, type, isMobile));
}

function getAction(isMobile){
    return isMobile ? 'MobileHeaderClick': 'DesktopHeaderClick';
}

function getCategory(isMobile){
    return isMobile ? 'MobileHeader': 'DesktopHeader';
}

function sendEvent(data) {
    if (window.dataLayer) {
        window.dataLayer.push({
            event: 'gaTriggerEvent',
            gaEventCategory: data.category,
            gaEventAction: data.action,
            gaEventLabel: data.label
        });
    }
}

export function getEventData(element, type, isMobile){
    const label = type === 'mouseover' ? element.innerText : 
        element.id === 'wells' ? 'Wells' : 
        /cart/gi.test(element.getAttribute('href')) ? 'Cart' :
        element.innerText;

    if(!type || !/mouseover|click/gi.test(type)){
        return null;
    }

    return {
        category: getCategory(isMobile),
        action: getAction(isMobile), 
        label
    };
}